import { gql } from "@apollo/client";

export const ruleFragment = gql`
  fragment RuleFragment on Rule {
    id
    code
    name
    description
    businessType
    implementationType
  }
`;
